import { fetchCurrentIdToken } from "../../util/login";

const API_URL = process.env.REACT_APP_API_URL;

export const get = async (path, options = {}) => {
  try {
    const token = await fetchCurrentIdToken();
    const response = await fetch(`${API_URL}${path}`, {
      method: "GET",
      headers: {
        Authorization: token || "",
        ...(options?.headers || {}),
      },
    });

    if (!response.ok) {
      return {
        error: {
          status: response.status,
          data: await response.text().catch(() => "Request failed"),
        },
      };
    }

    const data = await response.json();
    return { data };
  } catch (error) {
    const statusCode =
      error.response?.statusCode ||
      error.statusCode ||
      (error.message?.includes("404") ? 404 : 500);
    const data = error?.message || error?.data || error?.error?.data || "An unknown error occurred";
    return {
      error: {
        status: statusCode,
        data,
      },
    };
  }
};

export const post = async (path, body, options = {}) => {
  const { headers = {}, stringify = true } = options;
  try {
    const token = await fetchCurrentIdToken();
    const response = await fetch(`${API_URL}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token || "",
        ...(headers || {}),
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      return { error: await response.text().catch(() => "Request failed") };
    }

    if (stringify) {
      const data = await response.json();
      return { data };
    }
    return response.body;
  } catch (error) {
    return { error: error.message || "Request failed" };
  }
};
